import {createStore} from "vuex";

const store = createStore({
  state: {
    leadInfo: null,
    quizAnswers: null,
    eduAnswers: null,
    langAnswers: null,
    signupId: null,
    signupInfo: null,
    prevQuiz: null,
    prevSignupInfo: null,
  },
  mutations: {
    quizAnswers (state, quizAnswers) {
      state.quizAnswers = quizAnswers;
    },
    eduAnswers (state, eduAnswers) {
      state.eduAnswers = eduAnswers;
    },
    langAnswers (state, langAnswers) {
      state.langAnswers = langAnswers;
    },
    signupInfo (state, signupInfo) {
      state.signupInfo = signupInfo;
    },
    signupId (state, signupId) {
      state.signupId = signupId;
    },
    prevSignupInfo (state, prevSignupInfo) {
      state.prevSignupInfo = prevSignupInfo;
    },
    prevQuiz (state, prevQuiz) {
      state.prevQuiz = prevQuiz;
    },
    leadInfo (state, leadInfo) {
      state.leadInfo = leadInfo;
    },
    pref_program (state, pp) {
      // @ts-ignore
      state.leadInfo.lead.cf.pref_program = pp;
    }
  }
})

export default store;
